import {
  SIGN_OUT,
  SET_ERROR,
  SET_LOADING_VALUE,
  REFRESH_TOKEN,
  SET_USER_PERMISSION,
  SET_STATE_OFF_COOKIE,
  OKTA_OIDC_SIGN_IN,
} from './constants'
import { DEFAULT_INDEX_OBJECT } from './index'
import router from '@/router'
import jsCookie from 'js-cookie'
import { setState } from '@/store'
import Roles from './Roles'

const OFFSET_FOR_EXPIRES_IN = 270

const setExpires = function (state, expires_in) {
  const addForExpireTime = (expires_in - OFFSET_FOR_EXPIRES_IN) * 1000
  const expires = new Date(new Date().getTime() + addForExpireTime).getTime()
  state.expires = expires
}

const setCookie = function (state) {
  jsCookie.set(
    'auth',
    JSON.stringify({
      username: state.username,
      token: state.token,
      refreshToken: state.refreshToken,
      expires: state.expires,
    }),
  )
}

const getAuthCookie = function () {
  const cookie = jsCookie.get('auth')
  let credentials = {}
  if (cookie) {
    credentials = JSON.parse(cookie) // {username, token, refreshToken, expires}
  }
  return credentials
}

const setStateBasedOffCookie = function (state) {
  let c = getAuthCookie()
  if (c) {
    state.username = c.username
    state.token = c.token
    state.refreshToken = c.refreshToken
    state.expires = c.expires
  }
}

const mutations = {
  [OKTA_OIDC_SIGN_IN](state, credentials) {
    // does not set the permissionos, refreshToken, and roles currently...
    state.username = credentials.username
    state.token = credentials.accessToken
  },
  [SET_USER_PERMISSION](state, data) {
    state.userPermissions = data.permissions
    state.roles = new Roles(data.roles)
  },
  [SIGN_OUT](state) {
    state.loggingOut = true
    router.replace({ name: 'LOGOUT' })
  },
  [SET_ERROR](state, message) {
    console.log(message)
    state.error = message
  },
  [SET_LOADING_VALUE](state, value) {
    state.loading = value
  },
  [REFRESH_TOKEN](state, value) {
    console.log('REFRESH_TOKEN')
    console.log(value)
    state.token = value.access_token
    state.refreshToken = value.refresh_token
    setExpires(state, value.expires_in)
    setCookie(state)
    console.log('AUTO_REFRESH CHECKING THE STATE')
    console.log({
      state,
    })
  },
  [SET_STATE_OFF_COOKIE](state) {
    setStateBasedOffCookie(state)
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutations.js